import React from 'react';
import HeroBaner from './home-page/HeroBaner';
import Specialized from './home-page/Specialized';
import Testimonials from './home-page/Testimonials';
import AssociatePartners from './home-page/AssociatePartners';
import LatestArticles from './home-page/LatestArticles';
import SubscribeNewsletter from './home-page/SubscribeNewsletter';
import { Helmet } from 'react-helmet-async';
export default function Home() {
  return (
    <>

    <Helmet>
        <title>Best Family Doctors at your Door Step in Bengaluru and Delhi</title>
        <meta
          name="description"
          content="We provide experienced family physicians with 15+ years of expertise, offering trusted home healthcare services in  Bengaluru."
        />
        <meta
          name="keywords"
          content="talk to a doctor ,doctor visit at home"
        />
      </Helmet>

      <HeroBaner />
      <Specialized />
     
      <Testimonials />
      <AssociatePartners />
      <LatestArticles />
      <SubscribeNewsletter />
    </>
  );
}
